import { useState } from 'react'
import type { EvidenceItem } from '@/lib/api'
import { ReportImage } from './ReportImage'
import { Camera, ImageOff, X } from 'lucide-react'

export function PhotoPlate({ photos }: { photos: EvidenceItem[] }) {
  const [lightbox, setLightbox] = useState<string | null>(null)

  if (photos.length === 0) return null

  return (
    <>
      <div className="mt-4">
        <h4 className="text-xs font-bold text-slate-600 uppercase tracking-wider mb-3 flex items-center gap-1.5 border-b border-slate-200 pb-1.5">
          <Camera className="w-3.5 h-3.5" /> Photographic Evidence ({photos.length})
        </h4>
        <div className="grid grid-cols-2 gap-4">
          {photos.map((p, idx) => (
            <div key={p.id} className="border border-slate-200 rounded-lg overflow-hidden bg-white">
              <div
                className="aspect-[4/3] cursor-pointer bg-slate-100"
                onClick={() => (p.display_url ?? p.asset_url) && setLightbox((p.display_url ?? p.asset_url)!)}
              >
                {(p.display_url ?? p.asset_url) ? (
                  <ReportImage src={(p.display_url ?? p.asset_url)!} alt={p.description || `Photo ${idx + 1}`} className="w-full h-full" />
                ) : (
                  <div className="w-full h-full flex items-center justify-center text-slate-400">
                    <ImageOff className="w-8 h-8" />
                  </div>
                )}
              </div>
              <div className="px-3 py-2 bg-slate-50 border-t border-slate-200">
                <p className="text-xs font-medium text-slate-700 leading-tight">
                  {p.description || `Photo ${idx + 1}`}
                </p>
                <p className="text-[10px] text-slate-500 mt-0.5">
                  {p.captured_by_name || 'Unknown'} — {new Date(p.captured_at).toLocaleDateString('en-AU', { day: '2-digit', month: 'short', year: 'numeric' })}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {lightbox && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/85" onClick={() => setLightbox(null)}>
          <button onClick={() => setLightbox(null)} className="absolute top-4 right-4 p-2 rounded-full bg-white/10 hover:bg-white/20 text-white"><X className="w-5 h-5" /></button>
          <img src={lightbox} alt="Evidence" className="max-w-[90vw] max-h-[90vh] rounded-lg object-contain" onClick={e => e.stopPropagation()} />
        </div>
      )}
    </>
  )
}
